import { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { NewClip } from "./steps/step-new-clip/new-clip";
import { ClipConfiguration } from "./models";
import React from "react";
import { useMutation } from "react-query";
import { createClipConfig } from "data/mutations";
import { useIdentity } from "contexts/identity-context";
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";
import { DefineBoundary } from "./steps/step-define-boundary/define-boundary";
import utc from "dayjs/plugin/utc";

const stepsMapping = [
  {
    stepName: "New Clip",
    element: NewClip,
  },
  {
    stepName: "Define the clip boundary",
    element: DefineBoundary,
  },
];

export interface ClipStepsControlProps {
  activeStep: number;
  setActiveStep: React.Dispatch<React.SetStateAction<number>>;
  maxSteps: number;
}

export interface ClipConfigProps {
  clipConfig: ClipConfiguration;
  setClipConfig: React.Dispatch<React.SetStateAction<ClipConfiguration>>;
  saveClipConfig: () => void;
}

export const ClipMenu = () => {
  dayjs.extend(utc);

  const initialClipConfig: ClipConfiguration = {
    id: uuidv4(),
    name: "",
    activeStep: 0,
    status: "Draft",
    date: dayjs.utc().format(),
  };

  const [expanded, setExpanded] = useState(false);
  const [clipConfig, setClipConfig] =
    useState<ClipConfiguration>(initialClipConfig);
  const [activeStep, setActiveStep] = useState(clipConfig.activeStep);
  const [identityState] = useIdentity();

  useEffect(() => {
    setClipConfig((prevState) => {
      return {
        ...prevState,
        activeStep: activeStep,
      };
    });
    saveClipConfig();
  }, [activeStep]);

  const clipsCreateMutation = useMutation((clipConfig: ClipConfiguration) =>
    createClipConfig(clipConfig, identityState)
  );

  const saveClipConfig = () => {
    if (clipConfig.name && activeStep > 0)
      clipsCreateMutation.mutate(clipConfig);
  };

  const resetClipConfigForm = () => {
    setActiveStep(0);
    setClipConfig(initialClipConfig);
  };

  const classes = useStyles();
  return (
    <Card className={expanded ? classes.expanded : classes.minimized}>
      <CardHeader
        sx={{ width: "100%" }}
        action={
          <>
            {expanded && (
              <IconButton
                onClick={() => {
                  saveClipConfig();
                  resetClipConfigForm();
                  setExpanded(false);
                }}
              >
                <CloseIcon></CloseIcon>
              </IconButton>
            )}
            {!expanded && (
              <IconButton onClick={() => setExpanded(true)}>
                <AddIcon />
              </IconButton>
            )}
          </>
        }
        title="Clip"
      />
      <CardContent sx={{ width: "100%" }}>
        {React.createElement(stepsMapping[activeStep].element, {
          activeStep: activeStep,
          setActiveStep: setActiveStep,
          maxSteps: stepsMapping.length - 1,
          clipConfig: clipConfig,
          setClipConfig: setClipConfig,
          saveClipConfig: saveClipConfig,
        })}
      </CardContent>
    </Card>
  );
};

const useStyles = makeStyles({
  expanded: {
    maxHeight: "80vh",
    width: "430px",
  },
  minimized: {
    width: "116px",
    height: "59px",
  },
});
